import { Alert, Button, CircularProgress, Container, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { postDataWithParams } from 'src/consumer/services/profileService'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'

export default function EmailVerifyContent({ token, goToLoginButton }) {
  const [status, setStatus] = useState('loading') // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('')

  useEffect(() => {
    async function verifyEmail() {
      try {
        const resp = await postDataWithParams('/api/nc/account/email/verify', null, {
          token: token,
        })

        if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
          setStatus('success')
          setMessage('Your email has been successfully verified!')
        } else {
          const errorCode = resp?.data?.code
          if (errorCode === 5006) {
            setMessage('Your email is already verified.')
          } else if (errorCode === 4002) {
            setMessage('Invalid user. Please check the link.')
          } else if (errorCode === 5002) {
            setMessage('The verification link is invalid or has expired.')
          } else {
            setMessage('Something went wrong. Please try again later.')
          }
          setStatus('error')
        }
      } catch (e) {
        setStatus('error')
        setMessage('An unexpected error occurred.')
      }
    }

    verifyEmail()
  }, [token])

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
      {status === 'loading' && <CircularProgress />}
      {status !== 'loading' && (
        <>
          <Alert severity={status === 'success' ? 'success' : 'error'} className="mt-3">
            <Typography variant="h6">{message}</Typography>
          </Alert>

          {status === 'success' && isTokenInvalidOrAbsent() && (
            <Button variant="contained" className="mt-4" onClick={goToLoginButton}>
              Go to Login
            </Button>
          )}
        </>
      )}
    </Container>
  )
}
